<template>
  <div class="app-main-content">
    <div v-show="!showDetail" class="grid-view">
      <div
        v-show="showMainList"
        type="primary"
        class="main-content"
        style="height:100%;display: flex;flex-direction: column"
      >
        <search-item
          config-module="600"
          :reset="true"
          no="1"
          @click-more="value=>isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
        >
          <div slot="operations">
            <el-button type="success" no="2" @click="toLook()">{{ $t('common.btn.look') }}</el-button>
            <el-button type="primary" no="3" @click="toEdit()">{{ $t('common.btn.edit') }}</el-button>
            <el-button v-permission="['button_ProjectModule_delete']" type="danger" no="4" @click="toBatchDelete()">{{ $t('common.btn.delete') }}</el-button>
            <el-button type="success" no="5" @click="toAdd()">{{ $t('common.btn.new') }}</el-button>
            <el-button type="primary" no="6" @click="toExportToExcel()">{{ $t('common.btn.exportExcel') }}</el-button>
            <el-button type="primary" :disabled="yuhaiApiIsEdit" no="7" @click="toCloseProject()">{{ $t('Project.CloseProject') }}</el-button>
            <el-button type="primary" :disabled="yuhaiApiIsEdit" no="8" @click="toOpenProject()">{{ $t('Project.RebuildProject') }}</el-button>
          </div>
        </search-item>

        <div class="section grid-wrapper">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="gridParams"
            style="flex:1;width: 100%;height: 100%"
            no="9"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            v-show="filter.total>0"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            no="10"
            @pagination="toQuery"
          />
        </div>
      </div>
    </div>
    <!--详情-->
    <project-detail
      v-if="showDetail"
      ref="projectDetail"
      :row-uuid="rowUuid"
      :op="op"
      :view-source="detailViewSource"
      no="11"
      @backList="toBackPreView"
    />
  </div>

</template>

<script>
import URL from '@/api/urlTranslator'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getToken } from '@/utils/auth'
import { advancedQuery, findByProjectNo, batchDeleteProject, batchCloseProject, batchOpenProject
} from '@/api/projectManage/project'
import ProjectDetail from './components/project/projectDetail'
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { DocumentManage } from '@/utils/commonUtil'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import { getLoading } from '@/utils/utilBaseElement'
import { Assert } from '@/utils/validate'
import { cacheName, cache } from '@/utils/cacheManager'
export default {
  name: 'Project',
  components: { cargoAdvanceSelect, searchItem, cargoCloudFileUpload, ProjectDetail },
  data() {
    return {
      loading: null,
      isAdvancedQuery: false, // 是否为高级查询
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      filterJson: {},
      showDetail: false,
      rowUuid: '',
      op: 0,
      showBusinessCommission: false,
      selectTypeNames: TYPE_NAMES,
      detailViewSource: '', // detailView详情页的来源
      currentSessionId: getToken(),
      formTitle: '',
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: '', checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Project.ProjectNo'),
          field: 'projectNo',
          width: 150
        },
        {
          headerName: this.$t('Project.ProjectStatus'),
          field: 'projectStatusDesc',
          width: 150
        },
        {
          headerName: this.$t('Project.ProjectName'),
          field: 'projectName',
          width: 150
        },
        {
          headerName: this.$t('Project.CustomerName'),
          field: 'partenerChinesName',
          width: 150
        },
        {
          headerName: this.$t('Project.ProjectCycle'),
          field: 'projectCyCle',
          width: 150
        },
        {
          headerName: this.$t('Project.ProjectManager'),
          field: 'projectManagerChinesName',
          width: 150
        },
        {
          headerName: this.$t('Project.ExpectIncome'),
          field: 'expectIncome',
          width: 150
        },
        {
          headerName: this.$t('Project.ExpectCost'),
          field: 'expectCost',
          width: 150
        },
        {
          headerName: this.$t('Project.RealIncome'),
          field: 'realIncome',
          width: 150
        },
        {
          headerName: this.$t('Project.RealCost'),
          field: 'realCost',
          width: 150
        },
        {
          headerName: this.$t('Project.RealProfitTate'),
          field: 'realProfitTate',
          width: 150
        },
        {
          headerName: this.$t('Project.Remarks'),
          field: 'remarks',
          width: 150
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      documentManage: new DocumentManage(),
      yuhaiApiIsEdit: false
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail && !this.showBusinessCommission
    },
    url() {
      return URL
    }
  },
  beforeMount() {
    this.fetchProjectRequirement()
  },
  created() {
    this.documentManage.set('toShowFile', this.toShow)
    this.yuhaiApiIsEdit = (Number(cache.config.get('yuhaiApiIsEdit')) === 1) // 越海接口是否可编辑
  },
  methods: {
    fetchProjectRequirement() {
      this.loading = getLoading()
      this.filter.branchId = this.$store.getters.currentOfficeId
      findByProjectNo(this.filter).then(res => {
        this.filter.total = Number(res.data.total)
        this.rowData = res.data.list
      }).catch(() => {}).finally(() => {
        this.loading.close()
      })
    },

    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    // 查询
    toSimpleQuery(keyword) {
      this.loading = getLoading()
      if (typeof keyword !== 'undefined') {
        this.filter.projectNo = keyword
        this.filter.pageNum = 1
      }
      this.filter.branchId = this.$store.getters.currentOfficeId
      findByProjectNo(this.filter).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.fullscreenLoading.close()
    },
    toAdvancedQuery(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      advancedQuery(this.filterJson).then(res => this.handleQueryData(res)).finally(() => {
        this.loading.close()
      })
    },
    // 查看详情
    toLook() {
      this.detailViewSource = 'showMainList'
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length !== 1) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      this.showDetail = true
      this.rowUuid = rows[0].uuid
      this.op = 1
    },
    // 返回
    toBackPreView(toView) {
      this.showDetail = false
      if (toView === 'showMainList') {
        this.showBusinessCommission = false
      } else {
        this.showBusinessCommission = true
      }
      this.toQuery()
    },
    // 删除
    toBatchDelete() {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      console.log(rows)
      for (const item of rows) {
        if (item.projectStatus === 2) {
          self.$message.warning(item.projectNo + this.$t('ProjectManage.TheStatusCannotBeDeleted'))
          return
          // this.$message.error(item.projectNo + '当前项目状态无法进行删除操作')
        }
      }
      const uuids = Array.from(rows, p => p.uuid)
      const projectNos = Array.from(rows, p => p.projectNo)
      console.log('start update:' + uuids)
      this.$confirm('<p style=" width: 300px; word-break: break-word">' + this.$t('ProjectManage.PleaseToDeleteTheProject', [projectNos]) + '</p>', this.$t('ProjectManage.Prompt'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchDeleteProject(uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.DeletedSuccessfully'))
          this.fetchProjectRequirement()
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.DeletionCancelled'))
      })
    },
    // 新增
    toAdd() {
      this.detailViewSource = 'showMainList'
      this.showDetail = true
      this.rowUuid = undefined
      this.op = 3
    },
    // 编辑
    toEdit() {
      this.detailViewSource = 'showMainList'
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length !== 1) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      for (const item of rows) {
        if (item.projectStatus === 2) {
          self.$message.warning(item.projectNo + this.$t('ProjectManage.TheStatusCannotBeEdited'))
          return
        }
      }
      this.showDetail = true
      this.rowUuid = rows[0].uuid
      this.op = 2
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    // 导出Excel
    toExportToExcel() {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      var timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      // 获取选中行
      const fileName = 'ProjectList'
      const tHeader = []
      const filterVal = []
      for (const item of rows) {
        if (!item) continue
        for (const column of allDisplayedColumns) {
          const dataField = column.colDef.field
          if (!column.colDef.headerName || !dataField) continue
          if (!tHeader.includes(column.colDef.headerName) && !filterVal.includes(dataField)) {
            tHeader.push(column.colDef.headerName)
            filterVal.push(dataField)
          }
        }
      }
      import('@/vendor/Export2Excel').then(excel => {
        const data = this.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: fileName
        })
      })
    },
    // 关闭项目
    toCloseProject(from) {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      console.log(rows)
      for (const item of rows) {
        if (item.projectStatus === 2) {
          self.$message.warning(item.projectNo + this.$t('ProjectManage.ProjectStatusCompleted'))
          return
        }
      }
      const uuids = Array.from(rows, p => p.uuid)
      const projectNos = Array.from(rows, p => p.projectNo)
      console.log('start update:' + uuids)
      this.$confirm('<p style=" width: 300px; word-break: break-word">请确认可以关闭编号' + projectNos + '的项目</p>', this.$t('ProjectManage.Prompt'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchCloseProject(uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.ClosedSuccessfully'))
          if (from === undefined) {
            this.fetchProjectRequirement()
          }
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.CancelledClosing'))
      })
    },
    // 打开项目
    toOpenProject(from) {
      const rows = this.gridApi.getSelectedRows()
      const self = this
      if (rows.length === 0) {
        self.$message.warning(this.$t('ProjectManage.PleaseSelectARecord'))
        return
      }
      console.log(rows)
      for (const item of rows) {
        if (item.projectStatus === 1) {
          self.$message.warning(item.projectNo + this.$t('ProjectManage.ProjectStatusInProgress'))
          return
        }
      }
      const uuids = Array.from(rows, p => p.uuid)
      const projectNos = Array.from(rows, p => p.projectNo)
      console.log('start update:' + uuids)
      this.$confirm('<p style=" width: 300px; word-break: break-word">请确认需要重新打开编号' + projectNos + '的项目</p>', this.$t('ProjectManage.Prompt'), {
        dangerouslyUseHTMLString: true,
        confirmButtonText: this.$t('ProjectManage.Confirm'),
        cancelButtonText: this.$t('ProjectManage.Cancel'),
        type: 'warning'
      }).then(() => {
        return batchOpenProject(uuids).then(res => {
          this.$message.success(this.$t('ProjectManage.OpenedSuccessfully'))
          if (from === undefined) {
            this.fetchProjectRequirement()
          }
        })
      }).catch(() => {
        return Promise.reject(this.$t('ProjectManage.CancelledOpening'))
      })
    }
  }
}
</script>

<style scoped>
</style>
